export default __webpack_public_path__ + "images/X4.27b6cba.png";